import React from "react";
import { useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { setListingQueryParams } from "../../redux/reducers/propertyReducer";
import { useDispatch } from "react-redux";
import "../../styles/footer.css";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaApple,
  FaGooglePlay
} from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();

  const handleSearch = (propertyPurpose, propertyType) => {
    const tabMapping = {
      rent: "rent",
      sale: "sale",
      commercial: "commercial",
    };

    dispatch(
      setListingQueryParams({
        skip: 0,
        take: 6,
        currentPage: 1,
        property_purpose: propertyPurpose,
        property_type: propertyType,
      })
    );

    navigate(`/properties?tab=${tabMapping[propertyPurpose]}`, {
      state: { property_purpose: propertyPurpose, property_type: propertyType },
    });

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer-main-container">
      <div className="footer-grid-wrapper">
        <div className="footer-left-main">
          <div className="footer-logo-container" onClick={() => navigate("/")}>
            <img alt="sandseekers_logo" src="/icons/footer-logo.svg" />
          </div>

          <div className="contact-info-block">
            <div className="contact-item">
              <span className="contact-label">
                <FormattedMessage id="footer.customer_care" defaultMessage="Total Free Customer Care" />
              </span>
              <span className="contact-value">02-6277156</span>
            </div>
            <div className="contact-item">
              <span className="contact-label">
                <FormattedMessage id="footer.live_support" defaultMessage="Live Support" />
              </span>
              <span className="contact-value">info@sandseekers.ae</span>
            </div>
          </div>

          <div className="social-section">
            <h4 className="section-title">
              <FormattedMessage id="footer.social_follow" defaultMessage="Follow us on social media" />
            </h4>
            <div className="social-icons-wrap">
              <a href="https://www.facebook.com/people/Sandseekersrealestate-LLC/61560022119418/" className="social-icon-link" target="_blank"><FaFacebookF /></a>
              <a href="https://www.instagram.com/sandseekersrealestatellc/" className="social-icon-link" target="_blank"><FaInstagram /></a>
              <a href="https://www.linkedin.com/company/sand-seekers-real-estate-llc/" className="social-icon-link" target="_blank"><FaLinkedinIn /></a>
            </div>
          </div>
        </div>

        {/* Right Column: Newsletter and Links */}
        <div className="footer-right-main">
          {/* <div className="footer-newsletter-section">
            <h3 className="newsletter-title">
              <FormattedMessage id="footer.keep_updated" defaultMessage="Keep Yourself Up to Date" />
            </h3>
            <div className="newsletter-input-wrap">
              <input
                type="email"
                placeholder={intl.formatMessage({ id: "footer.email_placeholder", defaultMessage: "Your email" })}
              />
            </div>
          </div> */}

          <div className="footer-links-grid">
            {/* Popular Search */}
            <div className="links-column">
              <h4 className="column-title">
                <FormattedMessage id="footer.popular_search" defaultMessage="Popular Search" />
              </h4>
              <ul className="links-list">
                <li className="link-item" onClick={() => handleSearch("sale", "AP")}>
                  <FormattedMessage id="footer.listing_sale" defaultMessage="Apartment for Sale" />
                </li>
                <li className="link-item" onClick={() => handleSearch("rent", "AP")}>
                  <FormattedMessage id="footer.listing_rent" defaultMessage="Apartment for Rent" />
                </li>
                <li className="link-item" onClick={() => handleSearch("commercial", "OF")}>
                  <FormattedMessage id="footer.offices_rent" defaultMessage="Offices for Rent" />
                </li>
              </ul>
            </div>

            {/* Quick Links */}
            <div className="links-column">
              <h4 className="column-title">
                <FormattedMessage id="footer.quick_links" defaultMessage="Quick Links" />
              </h4>
              <ul className="links-list">
                <li className="link-item" onClick={() => navigate("/terms-of-conditions")}>
                  <FormattedMessage id="footer.terms_of_services" defaultMessage="Terms of Services" />
                </li>
                <li className="link-item" onClick={() => navigate("/privacy-policy")}>
                  <FormattedMessage id="footer.privacy_policy" defaultMessage="Privacy Policy" />
                </li>
                <li className="link-item" onClick={() => navigate("/contact-us")}>
                  <FormattedMessage id="contact" defaultMessage="Contact" />
                </li>
              </ul>
            </div>

            {/* Discovery */}
            <div className="links-column">
              <h4 className="column-title">
                <FormattedMessage id="footer.discovery" defaultMessage="Discovery" />
              </h4>
              <ul className="links-list">
                <li className="link-item" onClick={() => navigate("/", { state: { scrollTo: "ExploreTowns" } })}>
                  <FormattedMessage id="footer.abu_dhabi" defaultMessage="Abu Dhabi" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom-bar">
        <span><FormattedMessage id="footer.rights_reserved" defaultMessage="© 2026 Sand Seekers. All rights reserved." /></span>
        <div className="footer-bottom-links">
          <span className="footer-bottom-link" onClick={() => navigate("/privacy-policy")}>
            <FormattedMessage id="footer.privacy" defaultMessage="Privacy" />
          </span>
          <span className="footer-bottom-link" onClick={() => navigate("/terms-of-conditions")}>
            <FormattedMessage id="footer.terms_conditions" defaultMessage="Terms & Conditions" />
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
